<template>
  <b-columns is-multiline>
    <b-column class="is-full">
      <component :is="getComponentByAgentType" />
    </b-column>
    <b-column class="is-full">
      <agent-synonyms />
    </b-column>
  </b-columns>
</template>

<script>
import { mapGetters } from 'vuex'
import AgentChemicalAttributes from './attributes/chemical/AgentChemicalAttributes'
import AgentRadiologicalAttributes from './attributes/radiological/AgentRadiologicalAttributes'
import AgentBiologicalAttributes from './attributes/biological/AgentBiologicalAttributes'
import AgentSynonyms from './AgentSynonyms'
import { agentTypeEnum } from '@/store'

export default {
  components: {
    AgentChemicalAttributes,
    AgentRadiologicalAttributes,
    AgentBiologicalAttributes,
    AgentSynonyms
  },
  computed: {
    ...mapGetters(['selectedAgent']),
    getComponentByAgentType () {
      if (this.selectedAgent) {
        switch (this.selectedAgent.agent_type) {
          case agentTypeEnum.CAgent:
            return AgentChemicalAttributes
          case agentTypeEnum.RNAgent:
            return AgentRadiologicalAttributes
          case agentTypeEnum.BAgent:
            return AgentBiologicalAttributes
          case agentTypeEnum.BioMarker:
            return AgentChemicalAttributes
          default:
            return null
        }
      }
    }
  }
}
</script>

<style>
</style>
